import type { Role } from '../types/person';
import { ROLE_RANK } from '../constants/roles';

// Re-export so consumers can import from utils or constants
export { ROLE_RANK } from '../constants/roles';

/** Returns true if `userRole` is at least as privileged as `minimumRole`. */
export function roleIsAtLeast(userRole: Role, minimumRole: Role): boolean {
  return ROLE_RANK[userRole] >= ROLE_RANK[minimumRole];
}
